import { useCallback } from 'react'

import { DEFAULT_CATEGORY } from '@/constants/category'
import { type SearchCategory, useGetSearchCategoryQuery } from '@/generated/graphql-types'
import { updateSearchCategoryCache } from '@/utils/category/updateSearchCategoryCache'

export const useGetSearchCategory = (): {
  category: SearchCategory
  updateSearchCategory: (newCategory?: SearchCategory) => void
} => {
  const { data, client } = useGetSearchCategoryQuery()

  const category = data?.searchCategory ?? DEFAULT_CATEGORY

  const updateSearchCategory = useCallback(
    (newCategory?: SearchCategory) => {
      if (!newCategory) {
        updateSearchCategoryCache(DEFAULT_CATEGORY, client)
        return
      }

      updateSearchCategoryCache(newCategory, client)
    },
    [client]
  )

  return { category, updateSearchCategory }
}
